import { useState } from 'react';
import { Modal, Button } from '@components/ui';
import { expenseCategories, paymentMethods } from '@mocks/harcamalar';

export default function QuickExpenseModal({ isOpen, onClose, onSubmit }) {

    // Form Data
    const [amount, setAmount] = useState('');
    const [category, setCategory] = useState('malzeme');
    const [paymentMethod, setPaymentMethod] = useState('nakit');
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
    const [description, setDescription] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            type: 'expense',
            amount: parseFloat(amount),
            category,
            paymentMethod,
            date,
            description: description || `${category} harcaması`
        });
        resetForm();
    };

    const resetForm = () => {
        setAmount('');
        setCategory('malzeme');
        setPaymentMethod('nakit');
        setDate(new Date().toISOString().split('T')[0]);
        setDescription('');
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={resetForm}
            title="Hızlı Gider Girişi"
            size="md"
        >
            <form onSubmit={handleSubmit} className="space-y-5">

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1.5">Tutar (TL)</label>
                    <input
                        type="number"
                        required
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        className="w-full p-4 text-xl font-bold rounded-xl border border-border-light focus:border-error focus:ring-1 focus:ring-error outline-none text-error"
                        placeholder="0.00"
                        autoFocus
                    />
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1.5">Kategori</label>
                        <select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className="w-full p-3 rounded-xl border border-border-light bg-bg-primary text-sm focus:border-error focus:outline-none"
                        >
                            {expenseCategories.map(cat => (
                                <option key={cat.key} value={cat.key}>{cat.label}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1.5">Ödeme Yöntemi</label>
                        <select
                            value={paymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                            className="w-full p-3 rounded-xl border border-border-light bg-bg-primary text-sm focus:border-error focus:outline-none"
                        >
                            {paymentMethods.map(method => (
                                <option key={method.key} value={method.key}>{method.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1.5">Tarih</label>
                    <input
                        type="date"
                        required
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        className="w-full p-3 rounded-xl border border-border-light bg-bg-primary text-sm focus:border-error focus:outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1.5">Açıklama</label>
                    <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        className="w-full p-3 rounded-xl border border-border-light bg-bg-primary text-sm focus:border-error focus:outline-none"
                        placeholder="Örn: 50 torba çimento, Mart ayı maaşı..."
                    />
                </div>

                <div className="pt-2 flex gap-3">
                    <Button type="button" variant="outline" onClick={resetForm} className="flex-1">İptal</Button>
                    <Button type="submit" variant="danger" className="flex-[2]">Gideri Kaydet</Button>
                </div>
            </form>
        </Modal>
    );
}
